import React, { useEffect, useState } from "react";

import Storage from "../../../services/storage.service";
import Settings from "../../../services/settings.service";
import SpinnerTimeLoader from "../../../views/shared/timeLoading";

import FormSubmissionOutcome from "./FormSubmissionOutcome";
import RatingsForm from "./RatingsForm";
import SurveyIntroCard from "./FormEntry";

import { OUTCOME_TYPES } from "./data/submissionOutcomes";
import { submitSurveyApi } from "./api";
import { useSessionPersistedState } from "../../../hooks";
import Translation from "../../../services/translation.service";

const STEPS = {
  INTRO: "intro",
  RATING: "rating",
  OUTCOME: "outcome",
};

const Survey330Form = (props) => {
  const [step, setStep] = useSessionPersistedState("survey_step", STEPS.INTRO);
  const [selectedRating, setSelectedRating] = useSessionPersistedState(
    "survey_rating",
    null
  );
  const [feedback, setFeedback] = useSessionPersistedState(
    "survey_feedback",
    ""
  );
  const [outcomeType, setOutcomeType] = useSessionPersistedState(
    "survey_outcome_type",
    null
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    
    const cameFromProtectionChannelRedirect = Storage.get(
      "survey330_form_origin",
      true
    );

    if (
      cameFromProtectionChannelRedirect !== "FromProtectionChannelSurveySuccess"
    ) {
      window.location.href = "/join/#/protection-channel";
      return null;
    }
  }, []);

  const handleSurveyStep = (step) => {
    setStep(STEPS[step.toUpperCase()] || STEPS.INTRO);
    window.scrollTo(0, 0);
  };

  const setAndTrimFeedback = (value) => {
    setFeedback(value);
    setOutcomeType(null);
  };

  const handleRatingSubmit = async () => {
    try {
      setLoading(true);

      const operatorTCN = Storage.get("OperatorTCN", true);
      const selectedRatingValue = selectedRating?.value;

      const response = await submitSurveyApi({
        operatorTCN,
        rating: selectedRatingValue,
        feedback: feedback?.trim() || "",
      });

      const statusCode = response?.status;

      if (statusCode === 201 || statusCode === 200) {
        if (selectedRatingValue >= 4) {
          setOutcomeType(OUTCOME_TYPES.SUCCESS_POSITIVE);
        } else {
          setOutcomeType(OUTCOME_TYPES.SUCCESS_NEGATIVE);
        }

        setStep(STEPS.OUTCOME);
        clearLocalAndSessionStorage();
      } else {
        console.warn("Survey submission failed with status:", statusCode);

        setOutcomeType(OUTCOME_TYPES.FAILURE);
        setStep(STEPS.OUTCOME);
        clearLocalAndSessionStorageOnFailure();
      }
    } catch (error) {
      console.error("Survey submission error:", error);

      setOutcomeType(OUTCOME_TYPES.FAILURE);
      setStep(STEPS.OUTCOME);
      clearLocalAndSessionStorageOnFailure();
    } finally {
      setLoading(false);
      window.scrollTo(0, 0);
    }
  };

  const clearStorage = () => {
    window.localStorage.removeItem("protection_channel_redirect");
    window.localStorage.removeItem("protection_channel_redirect_url");
    window.localStorage.removeItem("protection_channel_step");
    Storage.clear("reportErrorStatus", true, true);
    Storage.clear("reportOtpError", true, true);
  };

  const goToSiteHome = () => {
    clearStorage();
    window.location.href = Settings.get("site_link") + Translation.activeLang + "/";
  };

  const resetRatingsState = () => {
    setSelectedRating(null);
    setFeedback("");
  };

  const stepProps = {
    goToSiteHome,
    feedback,
    setFeedback: setAndTrimFeedback,
    selectedRating,
    setSelectedRating,
    onContinue: handleSurveyStep,
    onSubmit: handleRatingSubmit,
    outcome: outcomeType,
    resetRatingsState: resetRatingsState,
  };

  const clearLocalAndSessionStorage = () => {
    sessionStorage.removeItem("survey_step");
    sessionStorage.removeItem("survey_rating");
    sessionStorage.removeItem("survey_feedback");
    sessionStorage.removeItem("survey_outcome_type");
    Storage.clear("survey330_form_origin", true);
    Storage.clear("OperatorTCN", true);
  };

  const clearLocalAndSessionStorageOnFailure = () => {
    sessionStorage.removeItem("survey_step");
    sessionStorage.removeItem("survey_outcome_type");
    Storage.clear("survey330_form_origin", true);
    Storage.clear("OperatorTCN", true);
  };

  const renderActiveStep = () => {
    switch (step) {
      case STEPS.INTRO:
        return <SurveyIntroCard {...stepProps} />;
      case STEPS.RATING:
        return <RatingsForm {...stepProps} />;
      case STEPS.OUTCOME:
        return <FormSubmissionOutcome {...stepProps} />;
      default:
        return null;
    }
  };

  return (
    <div className="root-survey-330-form">
      <div className="form-container">
        {loading ? <SpinnerTimeLoader /> : renderActiveStep()}
      </div>
    </div>
  );
};

export default Survey330Form;
